import { css } from 'emotion';
import { theme } from '../../config/theme';

export const CssGlobal = `
*,
*:before,
*:after {
  box-sizing: inherit;
}

html {
  text-rendering: optimizeLegibility;
  font-display: auto;

  body { 
    min-width: 300px;
  }

  /* safari overflow */
  html, body {
    position: relative;
    overflow-x: hidden;
    margin: 0;

  }

}
  ::selection {
    color: white;
    background-color: ${theme.colors.warm.base};
  }
/*
html {
  text-rendering: optimizeLegibility;
  font-display: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  -ms-overflow-style: scrollbar;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  @media (max-width: ${theme.breakpoints.m}),
    (max-device-width: ${theme.breakpoints.m}) {
    font-size: 16px !important h1 {
      font-size: 2.074rem;
    }
    h2 {
      font-size: 1.728rem;
    }
    h3 {
      font-size: 1.44rem;
    }
    h4 {
      font-size: 1.2rem;
    }
  }
  @media (max-width: ${theme.breakpoints.s}),
    (max-device-width: ${theme.breakpoints.s}) {
    font-size: 14px !important;
    h1 {
      font-size: 2.65rem;
    }
    h2 {
      font-size: 1.424rem;
    }
    h3 {
      font-size: 1.266rem;
    }
    h4 {
      font-size: 1.125rem;
    }
  }
  @media (max-width: ${theme.breakpoints.xs}),
    (device-width: ${theme.breakpoints.xs}) {
    font-size: 10.5px !important;
    h1 {
      font-size: 2.5rem;
    }
    h2 {
      font-size: 1.125rem;
    }
    h3 {
      font-size: 1rem;
    }
    h4 {
      font-size: 0.8125rem;
    }
  }
}

a:not([href]):not([tabindex]) {
  color: inherit;
  text-decoration: none;
  &:hover,
  &:focus {
    color: inherit;
    text-decoration: none;
  }
  &:focus {
    outline: 0;
  }
}
h1 {
  text-shadow: ${theme.set.light.shadow.text.small},-1px -1px 0 ${theme.colors.warm.base},
        1px -1px 0 ${theme.colors.warm.base},
        -1px 1px 0 ${theme.colors.warm.base},
        1px 1px 0 ${theme.colors.warm.base};
}
h2 {
  text-shadow: ${theme.set.light.shadow.text.small},-1px -1px 0 ${theme.colors.warm.base},
        1px -1px 0 ${theme.colors.warm.base},
        -1px 1px 0 ${theme.colors.warm.base},
        1px 1px 0 ${theme.colors.warm.base};
}

blockquote {
  border-left: 5px solid ${theme.colors.warm.base};
  padding-left: 1rem !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  font-style: italic;
  p {
    line-height: 1.3 !important;
  }
}

iframe, .gatsby-resp-iframe-wrapper {
  scrolling: no;
  frameborder: 0;
}
[tabindex="-1"]:focus {
  outline: none !important;
}
pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
}
figure {
  margin: 0 0 1rem 0;
}
img {
  vertical-align: middle;
}
[role="button"] {
  cursor: pointer;
}
a,
area,
button,
[role="button"],
input,
label,
select,
summary,
textarea {
  touch-action: manipulation;
}
button {
  transition: box-shadow ${theme.transitions.main.transition};
}
table {
  border-collapse: collapse;
  background-color: ${theme.colors.pure.white};
}
caption {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  color: ${theme.colors.pure.bright};
  text-align: center;
  caption-side: bottom;
}
th {
  text-align: left;
}
label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

button:-moz-focus-inner {
  border: 0;
}

button:focus {
  outline: 0px dotted;
  outline: 0px auto -webkit-focus-ring-color;
}
input,
button,
select,
textarea {
  line-height: inherit;
  outline: none;
}
input[type="date"],
input[type="time"],
input[type="datetime-local"],
input[type="month"] {
  -webkit-appearance: listbox;
}
textarea {
  resize: vertical;
}

p {
  position: relative;
  z-index: 1;
  top: 0px;
}
fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}
legend {
  display: block;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  line-height: inherit;
}
input[type="search"] {
  -webkit-appearance: none;
}
output {
  display: inline-block;
}
[hidden] {
  display: none !important;
}
.headroom-wrapper {
  position: fixed;
  width: 100%;
  z-index: 2000;
  align: center;
  .headroom--pinned {

  }

}
.headroom {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  width: 100%;
  border-bottom: 2px solid transparent;
  padding: 1rem 1.5rem;
  svg {
    height: 2.5rem;
    g {
    }
  }
}
.headroom--unfixed {
  position: relative;
  transform: translateY(0);
  transition: ${theme.transitions.headroom.transition};
}
.headroom--scrolled {
  transition: ${theme.transitions.headroom.transition};
}
.headroom--unpinned {
  position: absolute;
  transform: translateY(-100%);
  transition: ${theme.transitions.headroom.transition};
}
.headroom--pinned {
  position: fixed;
  transform: translateY(0);
  transition: ${theme.transitions.headroom.transition};
  box-shadow: ${theme.set.light.shadow.topNav};

  headroom-wrapper{
  }

  nav {
    a {
      color: ${theme.colors.cool.ink};
      &:hover {
        border-color: ${theme.colors.cool.ink};
        border-bottom: 2px solid ${theme.set.light.highlight};
        svg {
          g {
              fill: ${theme.colors.warm.base};
            }
        }
      }
      &:focus {
        color: ${theme.colors.cool.lead};
      }
    }
  }
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  svg {
    height: 2.5rem;
    g {
      fill: ${theme.colors.fire.light};
    }
  }
  span {
    color: ${theme.colors.cool.ink};
  }
  nav {
  }
}
*/
`;



// WEBPACK FOOTER //
// ./src/layouts/CssGlobal.jsx